import { User } from '../context/UserContext';

/**
 * User service that integrates with User Context
 * This replaces direct localStorage usage in services
 */

export interface LoginResponse {
  token: string;
  user: {
    id: string;
    name?: string;
    firstName?: string;
    lastName?: string;
    email?: string;
    phone?: string;
    timezone?: string;
  };
}

export interface RegisterResponse {
  token: string;
  user: {
    id: string;
    name?: string;
    firstName?: string;
    lastName?: string;
    email?: string;
    phone?: string;
    timezone?: string;
  };
}

/**
 * Process login response and return user data for Context
 */
export const processLoginResponse = (response: LoginResponse): User => {
  return {
    id: response.user.id,
    token: response.token,
    name: response.user.name,
    firstName: response.user.firstName,
    lastName: response.user.lastName,
    email: response.user.email,
    phone: response.user.phone,
    timezone: response.user.timezone,
  };
};

/**
 * Process register response and return user data for Context
 */
export const processRegisterResponse = (response: RegisterResponse): User => {
  return {
    id: response.user.id,
    token: response.token,
    name: response.user.name,
    firstName: response.user.firstName,
    lastName: response.user.lastName,
    email: response.user.email,
    phone: response.user.phone,
    timezone: response.user.timezone,
  };
};

/**
 * Clear user data (for logout)
 */
export const clearUserData = (): void => {
};



